import ContactForm from './ContactForm.vue'


export default {
  routers() {
    return [
      {
        path: '/contact',
        name: 'contact',
        component: ContactForm
      },
    ];
  }
}





// WEBPACK FOOTER //
// ./src/components/company/src/Router.js